import { render, staticRenderFns } from "./ToggleGroupsTable.vue?vue&type=template&id=6f0b9934&"
import script from "./ToggleGroupsTable.vue?vue&type=script&lang=js&"
export * from "./ToggleGroupsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/builds/iaai/products/maturity-assessment-tool/mat-website/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f0b9934')) {
      api.createRecord('6f0b9934', component.options)
    } else {
      api.reload('6f0b9934', component.options)
    }
    module.hot.accept("./ToggleGroupsTable.vue?vue&type=template&id=6f0b9934&", function () {
      api.rerender('6f0b9934', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ToggleGroupsTable.vue"
export default component.exports